import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';

import { PaymentFormValues } from 'components/Dialogs/Finance/PaymentDialog/PaymentSchema';

export interface PaymentAllocation {
  charge_id: string;
  amount: number;
}

export interface Payment extends PaymentFormValues {
  id: string;
}

export type CreatePaymentResult = Payment | null;
export type CreatePaymentParams = PaymentFormValues;

async function createPayment(params: CreatePaymentParams): Promise<CreatePaymentResult> {
  // make api call
  const result = await privateApi.post(`${import.meta.env.VITE_API_BASE_URL}/finance/payments`, params);

  // return the data object
  return result.data as Payment | null;
}

const useCreatePayment = createMutation<CreatePaymentResult, CreatePaymentParams, AxiosError<ErrorResponse>>({
  mutationFn: async (variables: CreatePaymentParams) => createPayment(variables),
});

export { createPayment, useCreatePayment };
